/*
 * @Author: chenjianxiong 2232943862@qq.com
 * @Date: 2025-11-19 09:44:02
 * @LastEditors: chenjianxiong 2232943862@qq.com
 * @LastEditTime: 2025-11-20 09:57:09
 * @FilePath: \easyrent_front\src\api\socialAsset.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 这里是封装好的aioxs
import request from "../util/request";

// 分页 post
export const getSocialAssetPage = (data: any) => {
  return request({
    url: "/rent/social/asset/user/paging",
    method: "post",
    data
  });
};
// 详情 get
export const getSocialAssetDetailApi = (id: string) => {
  return request({
    url: `/rent/social/asset/user/detail/${id}`,
    method: "get"
  });
};
// 收藏 get
export const getSocialAssetColletApi = (id: string) => {
  return request({
    url: `/rent/social/asset/user/collect/${id}`,
    method: "get"
  });
};

export const getUserCheckUserApi = (id: string) => {
  return request({
    url: `/rent/social/asset/user/check/${id}`,
    method: "get"
  });
};

